/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { StorageManagerCommon } from "./StorageManager.common";

export const StorageManager = new StorageManagerCommon();
